/* unplugin-vue-components disabled */import { render } from "./submenu.vue?vue&type=template&id=226e66e4"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-side/submenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "226e66e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('226e66e4', __exports__)) {
    console.log('reload')
    api.reload('226e66e4', __exports__)
  }
  
  module.hot.accept("./submenu.vue?vue&type=template&id=226e66e4", () => {
    console.log('re-render')
    api.rerender('226e66e4', render)
  })

}


export default __exports__